export const Color = {
  primary: "#06BF69",
  secondary: "#ACF2D1",
  tertialy: "#04BF55",
  accent: "#403BBF",
  gray: "#e3e3e3",
  light: "#F2F2F2",
  dark: "#333",
};
